<template>
  <div class="wrapper" style="padding: 2.6rem 0rem 2.6rem 0rem">
    <app-loader v-if="!listItems.length"></app-loader>
    <div v-else>
      <router-view :key="$route.fullPath" />
      <h6 class="text-black-shadow">{{ $t("SETTINGS.WELCOME") }}  <span v-if="$store.getters.user">{{$store.getters.user.first_name}}</span></h6>
      <app-list
        :options="{
          id: 'settings-list',
          type: 'card-settings',
          title: $i18n.t('SETTINGS.SETTINGS'),
          items: listItems
        }"
        @setLastFocused="setLastFocused($event)"
      />

      <div id="back-browser-root" ref="back" class="back-browser fadein-browser"
      @click="back" v-if="$store.getters.platform === 'browser'" v-show="$route.name !== 'settings'">
        <icon name="arrow-left"></icon>
      </div>

    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import { StatsRootSettings, enviroment } from '@/utils/constants'

export default {
  name: 'Settings',
  components: { 'app-list': List, 'app-loader': Loader },
  data () {
    return {
      listItems: [],
      setInterval: false,
      time: 0
    }
  },
  watch: {
    // al volver de otra ruta hacemos focus sobre la última lista seleccionada
    $route: function () {
      if (this.$route.name === 'settings') {
        SpatialNavigation.focus(this.lastFocused)
        SpatialNavigation.resume()
      }
    }
  },
  beforeMount: function () { window.Countly.q.push(['track_pageview', StatsRootSettings]) },
  mounted: function () {
    // back browser
    if (this.$store.getters.platform === 'browser') {
      this.setInterval = setInterval(() => {
        this.time = this.time + 1
        if (this.time >= 3 && this.$refs.back) {
          this.$refs.back.classList.remove('fadein-browser')
          this.$refs.back.classList.add('fadeout-browser')
        }
      }, 1000)

      this.$el.addEventListener('mousemove', () => {
        if (this.$refs.back) {
          this.$refs.back.classList.remove('fadeout-browser')
          this.$refs.back.classList.add('fadein-browser')
        }
        this.time = 0
      })
    }
  },
  created: function () {
    // metas
    // document.title = this.$i18n.t('MENU.SETTINGS')
    // document.querySelector('meta[name="Description"]').setAttribute('content', this.$store.getters.getData.display_name)
    const azureUser = localStorage.getItem('azure_user')

    if (!this.$store.getters.user) {
      // usuario demo
      // this.listItems.push({id: 'link-user', name: this.$i18n.t('SETTINGS.LINK-USER'), route: 'link-user', singleRoute: true, icon: 'mobile-alt'})
      // this.listItems.push({id: 'new-user', name: this.$i18n.t('SETTINGS.NEW-USER'), route: 'new-user', singleRoute: true, icon: 'user-plus'})
      this.listItems.push({id: 'login', name: this.$i18n.t('SETTINGS.LOGIN'), route: 'settings-login', singleRoute: true, icon: 'sign-in-alt'})
      // this.listItems.push({id: 'register', name: this.$i18n.t('SETTINGS.NEW-USER'), route: 'register', singleRoute: true, icon: 'user-plus'})
    } else {
      // usuario final
      this.listItems.push({id: 'unlink-user', name: this.$i18n.t('SETTINGS.UNLINK-USER'), route: 'unlink-user', singleRoute: true, icon: 'sign-out-alt'})
      // this.listItems.push({id: 'edit-user', name: this.$i18n.t('SETTINGS.EDIT-USER'), route: 'edit-user', singleRoute: true, icon: 'user'})
      // this.listItems.push({id: 'cards', name: this.$i18n.t('SETTINGS.CARDS'), route: 'cards', singleRoute: true, icon: 'id-card'})
      if (!azureUser) {
        this.listItems.push({id: 'settings-user', name: this.$i18n.t('SETTINGS.SETTINGS'), route: 'settings-user', singleRoute: true, icon: 'cog', openExternalURL: this.url})
      }
    }
    // común
    // this.listItems.push({id: 'info', name: this.$i18n.t('SETTINGS.INFO'), image: '', route: 'info', singleRoute: true, icon: 'info-circle'})

    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    back: function () { this.$router.go(-1) },
    keyBack () {
      if (this.$route.name === 'settings') {
        this.$router.replace({name: 'content'})
      }
    },
    setLastFocused (e) {
      this.lastFocused = e.id
    }
  },
  computed: {
    url: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/?rt=' + this.$store.getters.getRefreshToken
    }
  },
  beforeDestroy: function () {
    clearInterval(this.setInterval)
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  position: relative
  width: 100%;
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox

h6
  color: white
  font-size: 2.5rem
  margin-left: 1.7rem

</style>



// WEBPACK FOOTER //
// src/pages/settings/Settings.vue